module.exports = __webpack_public_path__ + "img/analyzing_process.8bbcc70f.svg";